import { render, staticRenderFns } from "./ContactAddress.vue?vue&type=template&id=816bd9ca&"
import script from "./ContactAddress.vue?vue&type=script&lang=js&"
export * from "./ContactAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports